'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Property = require('./property');
var Publication = require('./publication');
var Offer = require('./offer');
var Category = require('./category');
var Brochure = require('./brochure');
var Feature = require('./feature');
var Source = require('./source');
var Type = require('./type');
var Dpe = require('./dpe');
var DocumentType = require('./documentType');
var Elia = require('./elia');
var Overview = require('./overview');
var Medium = require('./medium');
var Document = require('./document');
var History = require('./history');
module.exports = /*#__PURE__*/function () {
  function PropertyServiceApi(http) {
    _classCallCheck(this, PropertyServiceApi);
    var propertyClient = http.extend({
      serviceName: "property"
    });
    this._property = new Property(propertyClient);
    this._publication = new Publication(propertyClient);
    this._offer = new Offer(propertyClient);
    this._category = new Category(propertyClient);
    this._brochure = new Brochure(propertyClient);
    this._feature = new Feature(propertyClient);
    this._source = new Source(propertyClient);
    this._type = new Type(propertyClient);
    this._dpe = new Dpe(propertyClient);
    this._documentType = new DocumentType(propertyClient);
    this._elia = new Elia(propertyClient);
    this._overview = new Overview(propertyClient);
    this._medium = new Medium(propertyClient);
    this._document = new Document(propertyClient);
    this._history = new History(propertyClient);
  }
  _createClass(PropertyServiceApi, [{
    key: "setHttp",
    value: function setHttp(http) {
      this._property.setHttp(http);
      this._publication.setHttp(http);
      this._offer.setHttp(http);
      this._category.setHttp(http);
      this._brochure.setHttp(http);
      this._feature.setHttp(http);
      this._source.setHttp(http);
      this._type.setHttp(http);
      this._dpe.setHttp(http);
      this._documentType.setHttp(http);
      this._elia.setHttp(http);
      this._overview.setHttp(http);
      this._medium.setHttp(http);
      this._document.setHttp(http);
      this._history.setHttp(http);
    }

    /**
    *
    * property
    *
    *  @returns {PropertyModel}
    */
  }, {
    key: "property",
    get: function get() {
      return this._property;
    }

    /**
    *
    * publication
    *
    *  @returns {PublicationModel}
    */
  }, {
    key: "publication",
    get: function get() {
      return this._publication;
    }

    /**
    *
    * offer
    *
    *  @returns {OfferModel}
    */
  }, {
    key: "offer",
    get: function get() {
      return this._offer;
    }

    /**
    *
    * category
    *
    *  @returns {CategoryModel}
    */
  }, {
    key: "category",
    get: function get() {
      return this._category;
    }

    /**
    *
    * brochure
    *
    *  @returns {BrochureModel}
    */
  }, {
    key: "brochure",
    get: function get() {
      return this._brochure;
    }

    /**
    *
    * feature
    *
    *  @returns {FeatureModel}
    */
  }, {
    key: "feature",
    get: function get() {
      return this._feature;
    }

    /**
    *
    * source
    *
    *  @returns {SourceModel}
    */
  }, {
    key: "source",
    get: function get() {
      return this._source;
    }

    /**
    *
    * type
    *
    *  @returns {TypeModel}
    */
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }

    /**
    *
    * dpe
    *
    *  @returns {DpeModel}
    */
  }, {
    key: "dpe",
    get: function get() {
      return this._dpe;
    }

    /**
    *
    * documentType
    *
    *  @returns {DocumentTypeModel}
    */
  }, {
    key: "documentType",
    get: function get() {
      return this._documentType;
    }

    /**
    *
    * elia
    *
    *  @returns {EliaModel}
    */
  }, {
    key: "elia",
    get: function get() {
      return this._elia;
    }

    /**
    *
    * overview
    *
    *  @returns {OverviewModel}
    */
  }, {
    key: "overview",
    get: function get() {
      return this._overview;
    }

    /**
    *
    * medium
    *
    *  @returns {MediumModel}
    */
  }, {
    key: "medium",
    get: function get() {
      return this._medium;
    }

    /**
    *
    * document
    *
    *  @returns {DocumentModel}
    */
  }, {
    key: "document",
    get: function get() {
      return this._document;
    }

    /**
    *
    * history
    *
    *  @returns {HistoryModel}
    */
  }, {
    key: "history",
    get: function get() {
      return this._history;
    }
  }]);
  return PropertyServiceApi;
}();